import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { trigger, transition, style, animate } from '@angular/animations';
import { EngineParamEntryService } from './engine-param-entry.service';
import { EngineParamReportService } from '../engine-param-report/engine-param-report.service';
import { Input } from '@angular/core';
import { SessionStorageService } from "angular-web-storage";
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { distinctUntilChanged, finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-engine-param-entry',
  templateUrl: './engine-param-entry.component.html',
  styleUrls: ['./engine-param-entry.component.scss'],
  animations: [
    trigger('rowAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-10px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'scaleY(0.8)', height: 0 }))
      ])
    ])
  ]
})
export class EngineParamEntryComponent implements OnInit {
  @Input() mode: 'add' | 'edit';
  @Input() vesselId!: number;
  @Input() voyageNumber!: string;
  form: FormGroup;
  showSuccess: boolean = false;
  engineParams: any[] = [];
  shipLoading: boolean = false
  dataAvailable: boolean = true;
  // oldValues: { [key: string]: any } = {};
  oldValues: { [index: number]: { [key: string]: any } } = {};

  // Variables to control dialog
  showDialog = false;
  dialogIndex: number = -1;
  dialogField: string = '';
  dialogOldValue: any;
  dialogNewValue: any;
  dialogId: any;
  dialogReason: string = '';
  showReasonError: boolean = false;
  @ViewChild("successbox", { static: true }) successbox: SwalComponent;
  @ViewChild("errorbox", { static: true }) errorbox: SwalComponent;

  constructor(private fb: FormBuilder, private eps: EngineParamEntryService, private eprs: EngineParamReportService, public session: SessionStorageService) {
    this.form = this.fb.group({
      params: this.fb.array([])
    });
  }

  ngOnInit(): void {
    this.mode === 'edit' ? this.loadEditData() : this.addRow();;
  }

  get params(): FormArray {
    return this.form.get('params') as FormArray;
  }

  createRow(data: any = {}): FormGroup {
    console.log('==data=createrow==', data); 
  
    const form = this.fb.group({
      id: [data.id || null],
      adjustment: [data.adjustmentCarreidOut || '', [Validators.maxLength(1000)]],
      remark: [data.remarks || '', [Validators.maxLength(1000)]],
      date: [data.date ? this.convertToDateInputValue(data.date) : ''],
  
      // Old values (for tracking changes)
      adjustmentOldValue: [data.old_adjustment || ''],
      remarkOldValue: [data.old_remark || ''],
      dateOldValue: [data.old_date || ''],
  
      // Comments for audit
      adjustmentReason: [data.adjustmentCarreidOutComment || ''],
      remarkReason: [data.remarksComment || ''],
      dateReason: [data.dateComment || ''],

      edited_by: [data.edited_by || ''],
      edited_on: [data.edited_on || ''],

      usersign: [data.usersign || '']


    });
  
    console.log('==FormGroup value==', form.getRawValue());
    return form;
  }
  
  

  onInput(index: number, controlName: 'adjustment' | 'remark') {
    const control = this.params.at(index).get(controlName);
    if (control && control.value && control.value.length >= 1000) {
      control.markAsTouched();
    }
  }

storeOldValue(index: number, controlName: 'adjustment' | 'remark' | 'date') {
  const control = this.params.at(index).get(controlName);
  
  if (control) {
    // Initialize object for index if it doesn't exist
    if (!this.oldValues[index]) {
      this.oldValues[index] = {};
    }

    this.oldValues[index][`${controlName}OldValue`] = control.value;

    console.log(`Old value stored at index ${index} under key '${controlName}OldValue':`, control.value);
    console.log('==Updated oldValues==', this.oldValues);
  } else {
    console.warn(`Control not found at index ${index} for controlName ${controlName}`);
  }
}


checkValueChange(index: number, controlName: 'adjustment' | 'remark' | 'date') {
  if (this.showDialog) {
    console.warn('Dialog is already open. Ignoring value change.');
    return; // 💡 Exit early to prevent dialog overlap
  }

  const control = this.params.at(index).get(controlName);
  const oldValueKey = `${controlName}OldValue`;

  console.log('checkValueChange called');
  console.log('Index:', index);
  console.log('Control Name:', controlName);
  console.log('Old Value Key:', oldValueKey);

  if (control) {
    const newValue = control.value;
    const oldEntry = this.oldValues[index];
    const oldValue = oldEntry ? oldEntry[oldValueKey] : undefined;

    console.log('Retrieved Old Value:', oldValue);
    console.log('New Value:', newValue);

    if (this.mode === 'edit') {
      console.log('Mode is edit');

      if (oldValue !== undefined && oldValue !== newValue) {
        console.log('Value has changed');

        const formGroup = this.params.at(index);
        const idControl = formGroup.get('id');
        const id = idControl ? idControl.value : null;

        console.log('Form Group ID:', id);

        this.askReason(index, controlName, oldValue, newValue, id);
      } else {
        console.log('No change in value detected or old value undefined');
      }
    } else {
      console.log(`Skipped: mode is '${this.mode}', not 'edit'`);
    }
  } else {
    console.warn(`Control not found at index ${index} for controlName ${controlName}`);
  }
}

  
  askReason(index: number, field: string, oldValue: any, newValue: any, id: any) {
    this.dialogIndex = index;
    this.dialogField = field;
    this.dialogOldValue = oldValue;
    this.dialogNewValue = newValue;
    this.dialogId = id;
    this.dialogReason = '';
    this.showDialog = true;
    this.toggleFormControls(true);
  }

  confirmReason() {
    if (!this.dialogReason || this.dialogReason.trim() === '') {
      this.showReasonError = true;
      return;
    }
  
    const index = this.dialogIndex;
    const field = this.dialogField;
    const oldValue = this.dialogOldValue;
    const newValue = this.dialogNewValue;
    const reason = this.dialogReason;
  
    const formGroup = this.params.at(index) as FormGroup;
  
    // Ensure tracking controls exist
    ['OldValue', 'NewValue', 'Reason'].forEach(suffix => {
      const controlKey = `${field}${suffix}`;
      if (!formGroup.contains(controlKey)) {
        formGroup.addControl(controlKey, new FormControl(''));
      }
    });
  
    // Also ensure metadata controls exist
    ['edited_by', 'edited_on', 'usersign'].forEach(key => {
      if (!formGroup.contains(key)) {
        formGroup.addControl(key, new FormControl(''));
      }
    });
  
    const userName = this.session.get('firstname') + ' ' + this.session.get('lastname');
    const userSign = this.session.get('userSignature');
    const editedOn = new Date().toISOString();
  
    // Patch field tracking values
    formGroup.patchValue({
      [`${field}OldValue`]: oldValue,
      [`${field}NewValue`]: newValue,
      [`${field}Reason`]: reason,
      edited_by: userName,
      edited_on: editedOn,
      usersign: userSign
    });
  
    console.log(`FormGroup at index ${index} updated with reason and metadata:`, formGroup.value);
  
    // Close dialog
    this.showDialog = false;
    this.toggleFormControls(false);
  
    // Optional: reset dialog variables
    this.dialogField = '';
    this.dialogOldValue = '';
    this.dialogNewValue = '';
    this.dialogReason = '';
  }
  
  cancelReason() {
    this.showDialog = false;
  }

  private convertToDateInputValue(timestamp: number): string {
    const date = new Date(timestamp);
    return date.toISOString().split('T')[0];
  }

  addRow(data: any = {}): void {
    this.params.push(this.createRow(data));
    setTimeout(() => {
      const container = document.querySelector('.form-container');
      if (container) {
        container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
      }
    }, 100);
  }

  removeRow(index: number, param: any): void {
    const paramId = param.value.id;
  
    Swal.fire({
      title: 'Confirm Deletion!',
      text: 'Are you sure you want to delete this entry?',
      type: 'warning', // ✅ older SweetAlert2 versions use "type" instead of "icon"
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        if (!paramId) {
          this.params.removeAt(index);
          return;
        }
  
        this.setLoading(true);
        this.eps.deleteParams(paramId, this.vesselId, this.voyageNumber).pipe(
          finalize(() => this.setLoading(false))
        ).subscribe({
          next: () => {
            this.params.removeAt(index);
            this.showSuccessMsg('Entry Deleted', 'Your entry has been successfully deleted.');
          },
          error: (err) => {
            console.error('Delete failed', err);
            this.showErrorMsg('Unable to Delete', 'Something went wrong while trying to delete the entry.');
          }
        });
      }
    });
  }
  

  loadEditData(): void {
    this.eprs.getEngineParameters(this.vesselId, this.voyageNumber).subscribe({
      next: (response) => {
        if (response.responsecode == 200) {
          this.params.clear();
          if (response && response.data) {
            this.engineParams = response.data;
            if (this.engineParams.length) {
              this.engineParams.forEach(item => this.addRow(item));
            } else {
              this.addRow();
            }
          }
        } else if (response.responsecode == 404) {
          this.dataAvailable = false;
          this.showErrorMsg('Data Not Found', 'No data is available for the specified vessel and voyage.');
        } else {
          this.handleUnexpectedResponse();
        }
      },
      error: (error) => {
        console.error('Error fetching engine parameters:', error);
        this.dataAvailable = false;
      }
    });
  }

  private handleUnexpectedResponse(): void {
    this.dataAvailable = false;
    this.showErrorMsg('Unexpected Error', 'An unexpected response was received from the server.');
  }

  showSuccessMsg(title: string, text: string) {
    this.successbox.title = title;
    this.successbox.text = text;
    this.successbox.show();
  }

  showErrorMsg(title: string, text: string) {
    this.errorbox.title = title;
    this.errorbox.text = text;
    this.errorbox.show();
  }

  onSubmit(): void {
    if (this.form.invalid) {
      return this.showErrorMsg('Form Invalid', 'Please check the form and try again.');
    }

    const rawParams = this.form.value.params;
    console.log('==rawParams==', rawParams);

    if (rawParams.some(this.isRowInvalid)) {
      this.showErrorMsg('Incomplete Row', 'Please fill all fields in every row before submitting.');
      return;
    }
    this.setLoading(true);
    const payload = this.generatePayload(rawParams);
    console.log('🔍 Payload Preview:', JSON.stringify(payload, null, 2));

    this.eps.saveParams(payload).pipe(finalize(() => this.setLoading(false))).subscribe({
      next: (res) => {
        this.showSuccess = true;
        setTimeout(() => this.showSuccess = false, 3000);
        this.showSuccessMsg('Saved', 'Your data has been saved successfully.');
        this.params.clear();
        this.mode === 'add' ? this.addRow() : this.loadEditData();
      },
      error: (err) => {
        this.handleUnexpectedResponse();
      }
    });
  }

  private generatePayload(params: any[]): any[] {
    const userId = this.session.get("userid");
    const userSign = this.session.get("userSignature");
    const userName = this.session.get('firstname') + ' ' + this.session.get('lastname');
    const editedOn = new Date().toISOString();
  
    return params.map(p => {
      const isNewEntry = this.mode === 'add' || !p.id;
  
      return {
        adjustmentCarreidOut: p.adjustment ? p.adjustment.trim() : '',
        adjustmentCarreidOutComment: p.adjustmentReason || '',
        old_adjustment: p.adjustmentOldValue || '',
  
        remarks: p.remark ? p.remark.trim() : '',
        remarkComment: p.remarkReason || '',
        old_remark: p.remarkOldValue || '',
  
        date: p.date ? new Date(p.date).toISOString() : null,
        dateComment: p.dateReason || '',
        old_date: p.dateOldValue || '',
  
        id: isNewEntry ? null : p.id,
        userId,
        usersign: isNewEntry ? userSign : p.usersign || null,
        vesselId: this.vesselId,
        voyageNumber: this.voyageNumber,
  
        edited_by: isNewEntry ? userName : p.edited_by || null,
        edited_on: isNewEntry ? editedOn : p.edited_on || null,
        reason: ''
      };
    });
  }
  
  private setLoading(state: boolean) {
    this.shipLoading = state;
  }

  private isRowInvalid(row: any): boolean {
    return !row.adjustment || row.adjustment.trim() === '' ||
      !row.remark || row.remark.trim() === '' ||
      !row.date || row.date.trim() === '';
  }

  private toggleFormControls(disable: boolean) {
    console.log('==disbale==', disable);
    this.params.controls.forEach((control) => {
      if(disable) {
        control.disable({ emitEvent: false });
      } else {
        control.enable({ emitEvent: false })
      }
    })
  }
}
